import { API, HOST } from '@/utils/http'
import { createOrgBoundSession } from '@/services/orgSession'

// Org-scoped geo token for tulum image URLs loaded through <img> (Planet scene
// thumbnails), which can't carry an Authorization header. apiv3 sets it as an
// HttpOnly cookie on /tulum (geo_token_{orgId}), so image URLs carry no token
// and stay stable across refreshes; JS only tracks { orgId, expiresAt }.

const geo = createOrgBoundSession('Geo token', async (orgId) => {
  const { data } = await API.post(`${HOST}/org/${orgId}/geo-token`, null, { withCredentials: true })
  return { expiresAt: data.expires_at }
})

export const refreshGeoToken = geo.refresh
export const clearGeoToken = geo.clear
export const bindGeoTokenToOrg = geo.bindToOrg

// The tulum image URL once the org's geo-token cookie is set, else null, so
// callers render nothing instead of an <img> that would 401. Reactive: read
// it in a computed or template and it fills in when the cookie lands.
export function withGeoToken(url, orgId) {
  const current = geo.session.value
  return current && String(current.orgId) === String(orgId) ? url : null
}
